export interface CatalogOfferGroups<T extends { id: string; name: string }> {
  mine: T[]
  shared: T[]
  public: T[]
}

/**
 * * One list of every resource the user can see.
 * * Visibility does not exclude a row. Associated rows stay, unless hidden.
 */
export function catalogOfferRows<T extends { id: string; name: string }>(
  groups: CatalogOfferGroups<T> | undefined,
  associatedIds: ReadonlySet<string>,
  hideAssociated: boolean,
): T[] {
  const rows = [
    ...(groups?.mine ?? []),
    ...(groups?.shared ?? []),
    ...(groups?.public ?? []),
  ].sort((left, right) => left.name.localeCompare(right.name, 'fr'))
  if (!hideAssociated) {
    return rows
  }
  return rows.filter((row) => !associatedIds.has(row.id))
}
